import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { useTranslation } from 'react-i18next';

const RetiredStaff = () => {
  const { t } = useTranslation();
  return <PageTemplate title={t('retired_staff.title')} />;
};

export default RetiredStaff; 